module.exports = [{"x":0,"y":0},{"x":8,"y":12},{"x":16,"y":24},{"x":24,"y":36},{"x":32,"y":48},{"x":40,"y":60},{"x":48,"y":72},{"x":60,"y":84},{"x":72,"y":72},{"x":80,"y":60},{"x":88,"y":48},{"x":96,"y":36},{"x":104,"y":24},{"x":112,"y":12},{"x":120,"y":0},{"x":104,"y":0},{"x":88,"y":0},{"x":80,"y":12},{"x":72,"y":24},{"x":60,"y":36},{"x":48,"y":24},{"x":40,"y":10},{"x":32,"y":0},{"x":16,"y":0}]


//////////////////
// WEBPACK FOOTER
// ./src/components/vuestic-components/vuestic-preloader/points.json
// module id = /QL9
// module chunks = 118